import "../../../design/TableUI.css";
import "../../../design/PaymentHistory.css";
import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API_URL } from "../../../api/API_SERVERS";
import { formatDateDMY } from "../../helper/helperFunctions";
import Loading from "../../otherComponents/Loading";

export default function PaymentHistory() {
    const [loading, setLoading] = useState(false);
    const [paymentsNumber, setPaymentsNumber] = useState(0);
    const [payments, setPayments] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState("");

    const getRequests = useCallback(async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${API_URL}/api/admin/payments-history?page=${page}&limit=10`, {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('AdminToken') }
            });
            const data = res.data.payments_history || res.data.payments || [];
            setPayments(data);
            setPaymentsNumber(res.data.total || 0);
            setTotalPages(res.data.totalPages || 1);
        } catch (e) { console.error(e); }
        setLoading(false);
    }, [page]);

    useEffect(() => { getRequests(); }, [getRequests]);

    const filteredPayments = payments?.filter(p => p.person_id?.toLowerCase().includes(search.toLowerCase())) || [];

    return (
        <>
            {loading && <Loading />}
            <div className="ph-stats-grid">
                <div className="ph-stat-card">
                    <p className="ph-stat-label">Total Transactions</p>
                    <h2 className="ph-stat-value">{paymentsNumber}</h2>
                </div>
                <div className="ph-stat-card success">
                    <p className="ph-stat-label">Current Page</p>
                    <h2 className="ph-stat-value">{page} <span style={{ fontSize: '0.9rem', color: 'var(--text-muted)' }}>/ {totalPages}</span></h2>
                </div>
            </div>

            <div className="ui-toolbar">
                <div className="ui-search-wrapper">
                    <input className="ui-search-input" type="text" placeholder="Search Person ID..." value={search} onChange={(e) => setSearch(e.target.value)} />
                </div>
                <div className="ui-pagination-controls">
                    <button className="ui-page-btn" disabled={page === 1} onClick={() => setPage(page - 1)}>Prev</button>
                    <button className="ui-page-btn" disabled={page >= totalPages} onClick={() => setPage(page + 1)}>Next</button>
                </div>
            </div>

            <div className="ui-table-container">
                <table className="ui-custom-table">
                    <thead>
                    <tr><th>#</th><th>Person ID</th><th>Amount</th><th>Type</th><th>Created</th><th>Expiry</th></tr>
                    </thead>
                    <tbody>
                    {filteredPayments.map((p, idx) => (
                        <tr key={idx}>
                            <td>{(page - 1) * 10 + (idx + 1)}</td>
                            <td style={{ fontWeight: 600 }}>{p.person_id}</td>
                            <td><span style={{ color: 'var(--success)', fontWeight: 700 }}>${p.amount}</span></td>
                            <td><span className="ui-status-badge ui-status-active">{p.payment_type}</span></td>
                            <td>{formatDateDMY(p.created_at)}</td>
                            <td>{formatDateDMY(p.expires_at)}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}